import produce from 'immer';
import { UserTypes } from '@/types/user';

export interface UserState {
  audio: boolean;
  remindOfTcrDeadline: boolean;
  tcrBannerDismissedStep: string | null;
}

export const initialState: UserState = {
  audio: null,
  remindOfTcrDeadline: null,
  tcrBannerDismissedStep: null,
};

const setTwilioAudioEnabled = (enable: boolean) => {
  if (enable) {
    window.sharedApi.unmuteIncomingCalls();
  } else {
    window.sharedApi.muteIncomingCalls();
  }
};

export const reducer = produce((state: UserState, action: any) => {
  switch (action.type) {
    case UserTypes.SET_USER: {
      state.audio = action.payload.user.audio;
      setTwilioAudioEnabled(state.audio);
      break;
    }
    case UserTypes.TOGGLE_AUDIO_SUCCESS: {
      state.audio = action.payload.audio;
      setTwilioAudioEnabled(state.audio);
      break;
    }
    case UserTypes.DISABLE_TCR_BANNER_SUCCESS: {
      state.remindOfTcrDeadline = action.payload.remindOfTcrDeadline;
      state.tcrBannerDismissedStep = action.payload.tcrBannerDismissedStep;
      break;
    }
  }
}, initialState);
